<template>
    <div class="block-parents">
        <div class="block-parents__body">
            <div class="block-parents__content">
                <span class="block-parents__title">Что важно <br> родителям</span>
                <div class="block-parents__box block-parents__box">
                    <p class="block-parents__text block-parents__text">
                        Когда ребенку исполняется три, заканчивается декретный отпуск. Теперь родителей снова заботят не только сроки введения прикорма, но и ежеквартальный отчет или ежемесячная выручка отдела.
                        <br>
                        <br>
                        Маме (или папе) потребуется время на адаптацию к новому образу жизни, время на дорогу до работы и отдых. Если садик — часть жилого квартала, где вы живете, по утрам можно будить ребенка за 20 минут до выхода.
                    </p>
                    <BlockParallax
                        fixed
                        speed="5.7"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box"
                    >
                        <img
                            srcset="../assets/10-img.jpg, ../assets/10-img@2x.jpg 2x"
                            src="../assets/10-img.jpg"
                            class="block-parents__img"
                        >
                        <div class="image-caption">Детский сад в проекте «Варшавское шоссе 141»</div>
                    </BlockParallax>
                    <BlockParallax
                        class="block-parents__icon block-parents__icon-lego-red-one"
                        speed="10"
                        direction="right"
                        transform="rotate"
                        fixed>
                        <img
                            srcset="@/assets/images/icons/lego-red.png, @/assets/images/icons/lego-red@2x.png 2x"
                            src="@/assets/images/icons/lego-red.png"
                        >
                    </BlockParallax>
                    <BlockParallax
                        class="block-parents__icon block-parents--icon-desktop block-parents__icon-lego-red-two"
                        speed="8"
                        direction="left"
                        transform="rotate"
                        fixed>
                        <img
                            srcset="@/assets/images/icons/lego-red.png, @/assets/images/icons/lego-red@2x.png 2x"
                            src="@/assets/images/icons/lego-red.png"
                        >
                    </BlockParallax>
                    <BlockParallax
                        class="block-parents__icon block-parents__icon-cube"
                        speed="13"
                        direction="left"
                        transform="rotate"
                        fixed>
                        <img
                            srcset="@/assets/images/icons/cube.png, @/assets/images/icons/cube@2x.png 2x"
                            src="@/assets/images/icons/cube.png"
                        >
                    </BlockParallax>
                </div>
            </div>
        </div>
        <div class="block-parents__mini-block mini-block">
            <div class="mini-block__title">
                <h4>Эволюция детских площадок: куда уплыли лебеди из&nbsp;покрышек</h4>
                <a href="https://pikabu.ru/story/_7085390" class="mini-block__button" target="_blank">
                    <span>Читать на&nbsp;Пикабу</span>
                </a>
            </div>
            <div class="mini-block__image">
                <img src="../assets/36-mini.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-parents {
        margin-top 3rem
        position relative
        +layout-md-and-up() {
            margin-top 11rem
        }
        &__body {
            position relative
            +layout-md-and-up() {
                display flex
            }
        }
        &__box {
            margin-top 2.2rem
            +layout-md-and-up() {
                display flex
            }
            +layout-md-and-up() {
                padding-left 8rem
            }
        }
        &__title {
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            margin-top 0
            color $color-text
            font-weight $font-semiBold
            display block
            +layout-sm-and-up() {
                text-align center
                padding 0
            }
            +layout-md-and-up() {
                font-size 3rem
                margin-top 0.5rem
                line-height 3.5rem
                text-align left
                padding-left 8rem

            }

        }
        &__text {
            margin 0
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            +layout-md-and-up() {
                max-width 35rem
                padding 0
            }
        }
        &__text-one {

        }
        &__img-box {
            margin-left -1rem
            margin-right -1rem
            margin-top 2rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left auto
            }
            +layout-md-and-up() {
                margin-top -9rem
                margin-left 5rem
            }
        }
        &__img {
            width 100%
            margin-left auto
            display block
            +layout-sm-and-up() {
                align-self flex-start
                margin-right 0
            }
        }

        &__icon {
            position absolute
        }
        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__icon-lego-red-one {
            right -4rem
            top -1.4rem
            width 8rem
            +layout-md-and-up() {
                right auto
                left -24.6rem
                top 7rem
                width 12rem
            }
        }
        &__icon-lego-red-two {
            +layout-md-and-up() {
                right -10.1rem
                top -3.3rem
                width 8rem
            }
        }
        &__icon-cube {
            left 3rem
            top 16.7rem
            width 6.7rem
            transform rotate(59deg)
            z-index -1
            +layout-md-and-up() {
                right -24.5rem
                left auto
                top 6rem
                transform rotate(0deg)
                width 11rem

            }
        }
    }

    .mini-block {
        clear both
        display block
        width 100%
        max-width 640px
        margin 5rem auto
        display flex
        flex-direction row-reverse
        flex-wrap nowrap
        &__title {
            max-width 320px
            h4 {
                padding-bottom 31px
                font-size 24px
                font-weight 600
                letter-spacing 0.26px
                line-height 1.44
                color: #222222
            }
        }
        &__button {
            padding 13px 39px 14px
            font-size 16px
            font-weight 600
            letter-spacing 0.17px
            border-radius 5px
            background-color #fab903
            color #fff
            &:hover {
                background-color #ffc41d
            }
        }
        &__image {
            margin-right 4rem
            img {
                width auto
                max-height 215px
            }
        }
        @media screen and (max-width: 700px) {
            max-width 410px
            flex-direction row-reverse
            &__image {
                overflow hidden
                width 8rem
                height 8rem
                border-radius 50%
                margin-right 2rem
                
                img {
                    width auto
                    height 100%
                }
            }
        }
        @media screen and (max-width: 470px) {
            padding 1rem
            &__image {
                display none
            }
        }
    }
</style>
